<template>
  <div>
    <header class="lke-header">
      <div class="lke-header-in">
        <img src="@/pages/practice/assets/img/logo.jpg" alt="" />
      </div>
    </header>
    <div class="lke-mid-bg" :style="{ minHeight: bgHeight - 160 + 'px' }">
      <div class="lke-mid-in" :style="{ minHeight: bgHeight - 160 + 'px' }">
        <div class="lke-mid">
          <img
            class="lke-mid-img"
            src="@/pages/practice/assets/img/v2_qkciaf.svg"
            alt=""
          />
          <div class="lke-mid-login" v-loading="loginloading">
            <div class="lke-mid-login-title">
              <div
                class="lke-mid-login-title-tab"
                :class="{ active: tabNum == index }"
                v-for="(tab, index) in tab"
                :key="index"
                @click="changeLogin(index)"
              >
                {{ tab }}
              </div>
            </div>
            <div class="lke-mid-login-fot">
              <el-form
                @keyup.enter.native="submitLogin()"
                label-position="top"
                :rules="rules"
                :model="ruleForm"
                ref="ruleForm"
                label-width="0px"
                class="demo-ruleForm"
              >
                <el-form-item prop="username" style="margin: 20px 0">
                  <el-input
                    placeholder="请输入账号"
                    v-model="ruleForm.username"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" style="margin: 20px 0">
                  <el-input
                    placeholder="请输入密码"
                    type="password"
                    v-model="ruleForm.password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item prop="code" style="margin: 20px 0">
                  <div class="lke-code">
                    <el-input
                    placeholder="请输入验证码"
                    v-model="ruleForm.code"
                  ></el-input>
                  <span @click="captcha()" v-html="svg"></span>
                  </div>
                </el-form-item>
                <el-form-item
                  style="display: flex; justify-content: center; margin: 20px 0"
                >
                  <el-button
                    :loading="loading"
                    style="width: 100%"
                    type="primary"
                    @click="submitLogin()"
                    >{{ tab[tabNum] }}</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lke-fot">
      <div class="lke-fot-in">
        <div class="lke-fot-in-top">
          <div
            class="lke-fot-in-top-tab"
            :class="{ left: index === 0 }"
            v-for="(tabs, index) in fottabs"
            :key="index"
          >
            {{ tabs }}
          </div>
        </div>
        <div class="lke-fot-in-fot">Copyright © 东和文化传媒 2020-2050</div>
      </div>
    </div>
  </div>
</template>

<script>
import { login , captcha } from "@/api/login";
import { setToken, getToken } from "@/utils/auth";
export default {
  name: "login",
  data() {
    return {
      loginloading: false,
      bgHeight: 100,
      loading: false,
      tab: ["学生登陆"],
      tabNum: 0,
      fottabs: ["帮助中心", "服务支持", "加入我们", "关于我们", "友情链接"],
      ruleForm: {
        username: "",
        password: "",
        code: "",
        _id: ""
      },
      svg: '',
      rules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码长度不可低于6位", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "请输入正确的4位验证码", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.captcha()
    if (getToken()) {
      this.$router.push({ name: "indexPage" });
    }
    this.bgHeight = window.innerHeight;
    // if (this.$route.params.id) {
    //     this.tabNum = this.$route.params.id
    // }
  },
  mounted() {},
  filters: {},
  watch: {},
  methods: {

    captcha() {
      captcha().then(res=>{
        this.ruleForm._id = res._id
        this.svg = res.svg
      })
    },

    changeLogin(index) {
      //切换登陆类型
      this.tabNum = index;
    },

    submitLogin() {
      //登陆验证
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
            this.loading = true;
            this.loginloading = true;
            const ruleForm = {
            username: this.ruleForm.username.toString().replaceAll(' ', ''),
            password:  this.ruleForm.password.toString().replaceAll(' ', ''),
            code:  this.ruleForm.code.toString().replaceAll(' ', ''),
            _id:  this.ruleForm._id
          }
          login(ruleForm).then((response) => {
            setToken(response.token.token);
            this.$router.push({ name: "indexPage" });
            this.loading = false;
            this.loginloading = false;
          }).catch(()=>{
            this.captcha()
            this.loading = false;
            this.loginloading = false;
          })          // if (this.tabNum *1 === 0) {
          //     this.loading = true;
          //     setTimeout(() => {
          //         this.loading = false;
          //         this.$store.commit("userInfo", 1)
          //         this.$router.push({ name: 'indexPage' });
          //     }, 1000);
          // } else if(this.tabNum *1 === 1) {
          //     this.loading = true;
          //     setTimeout(() => {
          //         this.loading = false;
          //         this.$store.commit("userInfo", 1)
          //         this.$router.push({ name: 'grzxIndex' });
          //     }, 1000);
          // }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>

<style scoped>
::v-deep.el-form-item__content {
  width: 100% !important;
}
::v-deep.el-button--primary {
  width: 100% !important;
}
.lke-code{
  display: flex;
  justify-content: center;
}
.lke-code > span{
  flex-shrink: 0;
}
.lke-header {
  background: #fff;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  height: 60px;
}
.lke-header-in {
  width: 1024px;
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
}
.lke-mid-in {
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.lke-fot {
  height: 100px;
  width: 100%;
  background: #2e2e41;
}
.lke-mid {
  display: flex;
  align-items: center;
}
.lke-mid-img {
  width: 400px;
  height: 300px;
  margin-right: 50px;
}
.lke-mid-login {
  width: 320px;
  background: #fff;
  height: 350px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  padding: 40px;
}
.lke-mid-login-title {
  padding: 5px 0 20px 0;
  display: flex;
}
.lke-mid-login-title-tab {
  margin-right: 20px;
  padding-bottom: 2px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
}
.lke-mid-login-title-tab.active {
  border-bottom: 3px solid #2890f4;
}
.lke-mid-login-fot {
  padding-top: 20px;
}
.lke-fot-in {
  height: 100px;
  width: 1024px;
  background: #2e2e41;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.lke-fot-in-top {
  display: flex;
  align-items: center;
  color: #818893;
  font-size: 11px;
  margin-bottom: 10px;
}
.lke-fot-in-top-tab {
  padding: 0 10px;
  border-left: 1px solid #818893;
  cursor: pointer;
}
.lke-fot-in-top-tab.left {
  border-left: 1px solid #2e2e41;
}
.lke-fot-in-fot {
  color: #818893;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/login.vue